import React from 'react'

import { Checkbox } from '../../../main/components/checkbox'
import { CreateAlertInputProps } from './types'

type EventType = 'news' | 'rating' | 'insider'
type EventOptionType = {
  name: EventType
  label: string
}

const EVENTS: EventOptionType[] = [
  {
    name: 'news',
    label: 'News',
  },
  {
    name: 'rating',
    label: 'Ratings',
  },
  {
    name: 'insider',
    label: 'Insiders',
  },
]

export default function EventCheckboxes(props: CreateAlertInputProps) {
  const handleChange = React.useCallback(
    (ev: React.FormEvent<HTMLInputElement>, name: EventType) => {
      const checked = ev.currentTarget.checked

      if (checked && !props.errors?.isEmpty) props.setErrors((errors) => ({ ...errors, isEmpty: false }))
      props.setState((prev) => ({ ...prev, [name]: checked }))
    },
    [props]
  )

  return (
    <div className="flex justify-between">
      {EVENTS.map((event) => (
        <Checkbox
          key={event.name}
          isSmall
          checked={props.state[event.name]}
          onChange={(e) => handleChange(e, event.name)}
        >
          {event.label}
        </Checkbox>
      ))}
    </div>
  )
}
